module.exports = __webpack_public_path__ + "static/services-image-6_m-57436880f8bf3f090a9aee49a325a8db.jpg";